export default [
    {
        path: '/admin/halls',
        name: 'indexHallsAdmin',
        meta: { title: 'indexHallsAdmin' },
        component: () => import('@/pages/admin/halls'),
    },
    {
        path: "/admin/halls/create",
        name: "createHallsAdmin",
        meta: { title: 'createHallsAdmin' },
        component: () => import('@/pages/admin/halls/create'),
    },
    {
        path: "/admin/halls/:id/edit",
        name: "editHallsAdmin",
        meta: { title: 'editHallsAdmin' },
        component: () => import('@/pages/admin/halls/edit'),
    },
]